// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__3VCXJ","title":"Login_title__2KIWw","subtitle":"Login_subtitle__3ZtV2","form":"Login_form__YHM9R","field":"Login_field__1wBF7"};